import script from "./ConsumerMypageWishListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerMypageWishListView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerMypageWishListView.vue?vue&type=style&index=0&id=4c9c6f94&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c9c6f94"]])

export default __exports__